/* istanbul ignore file */
import { css } from 'styled-components';
import { theme as econsultTheme } from '@econsult/econsult-ui';

/** Layout */
const maxPageWidth = '100%';
const minPagePadding = '1.25rem';
const mediaXSAndAbove = (args: TemplateStringsArray) => css`
  @media (min-width: ${econsultTheme.screenLg}px) {
    ${css(args)};
  }
`;

/** Header */
const headerImgSize = '1.6875rem';
const headerGapSize = '0.75rem';

/** Font colors */
const fontColorShadeTwo = '#4D4D4D';
const invalidColor = '#c83c29';
const headerHoverFontColor = '#1e194b';
const neutral = '#625E81';
const summarySubtitle = '#34305D';
const summaryContent = '#000000';

/** Status colors */
const colorUrgentState = '#CF442F';

/** Background color */
const infoBackgroundColor = '#d7f4fe';
const warningBackgroundColor = '#fee1cd';
const headerHoverColor = '#74d7fb';

const hiddenScrollbarStyles = css`
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;  /* Hide scrollbar for IE and Edge */
  scrollbar-width: none;  /* Hide scrollbar for Firefox */
  ::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome, Safari and Opera */
  }
`;

const ghostColorShadeOne = '#EFEFEF';
const ghostColorShadeTwo = '#ECECED';
const ghostColorShadeThree = '#DFDFDF';
const ghostColorShadeFour = '#D8D8DA';
const ghostBackgroundColorShadeOne = '#F9F9F9';
const ghostBackgroundColorShadeTwo = '#F3F3F3';

const bPReadingColorNeutral = '#34305D';
const bgModalContainer = '#E9E8ED';
const bgModalPatientInfo = '#F8F6F7';
const wrapperModalCloseButton = '#1E194B';
const helperTextColor = '#8F8CA5';
const patientInfoRowColor = '#4B476F';
const warningColor = '#b85000';
const bgPatientMatchConflict = '#FEE1CD';
const textColorPurple = '#1E194B';
const previewModeWarningBackground = '#E29603CC';

// const dividerBorderPrimary = '1px solid #F0F0F0';
// const dividerBorderSecondary = '1px solid #E5E5E5';
// const dividerBpReading = '1px dashed #34305D';
// const dropdownPrimary = '#34305D';
const matchingContainerBorder = '1px solid #BCBAC9';
const matchingContainerBorderColor = ' #BCBAC9';
const dividerMatchingRight = '1px solid #D2D1DB';
const borderPatientMatchConflict = '1px solid #B85000';

export default {
  ...econsultTheme,
  fontColorShadeTwo,
  maxPageWidth,
  minPagePadding,
  mediaXSAndAbove,
  headerImgSize,
  headerGapSize,
  colorUrgentState,
  invalidColor,
  headerHoverColor,
  headerHoverFontColor,
  neutral,
  summarySubtitle,
  summaryContent,
  infoBackgroundColor,
  warningBackgroundColor,
  hiddenScrollbarStyles,
  // extra
  ghostColorShadeOne,
  ghostColorShadeTwo,
  ghostColorShadeThree,
  ghostColorShadeFour,
  ghostBackgroundColorShadeOne,
  ghostBackgroundColorShadeTwo,
  bPReadingColorNeutral,
  bgModalContainer,
  bgModalPatientInfo,
  wrapperModalCloseButton,
  matchingContainerBorder,
  matchingContainerBorderColor,
  dividerMatchingRight,
  helperTextColor,
  patientInfoRowColor,
  warningColor,
  bgPatientMatchConflict,
  borderPatientMatchConflict,
  textColorPurple,
  previewModeWarningBackground,
};
